import { httpClient } from '@/httpClient/axios.ts';

export const getCsrfToken = () => {
  // get a csrf cookie from the backend
  return httpClient
    .get(`/api/v1/csrf`, {
      headers: {
        credentials: 'include',
      },
    })
    .catch(() => {
      return false;
    });
};
